export const publications = [
  {
    title: 'Climate Finance Flows in East Africa',
    category: 'Working Papers',
    description: 'Analysis of climate finance mechanisms and their effectiveness in East African countries.',
    date: 'March 2024'
  },
  {
    title: 'Green Bonds Market Development',
    category: 'Policy Briefs',
    description: 'Assessment of green bonds market potential and policy recommendations for African nations.',
    date: 'February 2024'
  },
  {
    title: 'Climate Adaptation Finance Gaps',
    category: 'Journal Articles',
    description: 'Comprehensive study of adaptation finance needs and current funding gaps in Africa.',
    date: 'January 2024'
  },
  {
    title: 'Sustainable Energy Investment',
    category: 'Working Papers',
    description: 'Analysis of investment patterns in renewable energy projects across Africa.',
    date: 'December 2023'
  },
  {
    title: 'Carbon Markets in Africa',
    category: 'Policy Briefs',
    description: 'Policy framework analysis for developing carbon markets in African countries.',
    date: 'November 2023'
  },
  {
    title: 'Climate Finance Readiness',
    category: 'Journal Articles',
    description: 'Assessment of institutional capacity for climate finance in African nations.',
    date: 'October 2023'
  }
];

export const researchers = [
  {
    name: 'Dr. Sarah Kimani',
    role: 'Lead Researcher, Climate Economics',
    expertise: 'Specializing in climate finance mechanisms and economic policy analysis',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e',
    email: 'sarah.kimani@cfsc.africa',
    linkedin: 'https://linkedin.com/in/sarahkimani'
  },
  {
    name: 'Dr. James Okello',
    role: 'Senior Researcher, Sustainable Finance',
    expertise: 'Expert in green bonds and sustainable investment strategies',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e',
    email: 'james.okello@cfsc.africa',
    linkedin: 'https://linkedin.com/in/jamesokello'
  },
  {
    name: 'Dr. Amina Hassan',
    role: 'Research Fellow, Energy Finance',
    expertise: 'Focusing on renewable energy investment and policy frameworks',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956',
    email: 'amina.hassan@cfsc.africa',
    linkedin: 'https://linkedin.com/in/aminahassan'
  }
];